export default __webpack_public_path__ + "static/media/tracer-dejavu.fef0e4ad.mp3";